import * as Yup from 'yup'

export const richTextValidationSchema = Yup.object().shape({
  content: Yup.object().shape({
    richText: Yup.lazy((value) =>
      typeof value === 'string' ? Yup.string() : Yup.object()
    ),
  }),
})
